import { Exercise } from "./exercise.interface";
import { getNowInUnix } from "./time.interface";
import { userWorkoutTemplate } from "./user.interface";

export interface Workout {
  workoutName: string;
  startTime: number;
  exercises: Exercise[];
  lastSetCompleted?: number;
  templateId?: string;
  endTime?: number;
  currentlyWorkingOut?: boolean;
  workoutNote?: string;
  showExtraDetails?: boolean; // used to help with workoutHistory cards
}

export interface SubmitWorkoutData {
  formatedExercies: Exercise[];
  workoutData: Workout;
  templateId?: string;
}

export interface UpdateWorkoutData {
  workoutName?: string;
  date?: string;
  startTime?: number;
  exercises?: Exercise[];
}

export function calculateOneRepMax(weight: number, reps: number): number {
  return weight / (1.0278 - 0.0278 * reps);
}

export function generateEmptyWorkout(): Workout {
  return {
    workoutName: "Workout",
    startTime: getNowInUnix(),
    exercises: [],
    currentlyWorkingOut: true,
    workoutNote: "",
    showExtraDetails: true,
  };
}

export function formatWorkoutDocId(startTime: number): string {
  return `${startTime}`;
}

export function convertUserWorkoutTemplateToWorkout(
  workoutTemplate: userWorkoutTemplate
): Workout {
  const formattedWorkout: Workout = {
    workoutName: workoutTemplate.workoutName,
    startTime: getNowInUnix(),
    exercises: workoutTemplate.exercises,
    workoutNote: "",
    currentlyWorkingOut: true,
    showExtraDetails: true,
    templateId: workoutTemplate.id,
  };

  return formattedWorkout;
}
